export interface RespondentEmailValidationModel {
  groupId: string;
  respondentGroupIndex: number;
  participantId: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  avatar: string;
  isValid: boolean;
  onlyCheckBounced: boolean;
  errorMessage: string;
  locale: string;
  languageId: number;
}
